<template>
  <div class="charge-manage">
    <reader-list v-if="showReaderList" :goods-obj="orderGoods" @goBack="showReaderList = false"></reader-list>
    <template v-else>
      <ListHeader class="questionnaire-data-header" :showVipMessage="false" :listTitle="'鉴权阅读管理'"></ListHeader>
      <div class="export-btn" @click="exportOrder('')">
        <img src="@imgs/export-icon.png" />
        <span>批量导出订单信息</span>
      </div>
      <div class="navigation">
        <el-radio-group @change="changeModule" v-model="currentModule">
          <el-radio class="title-radio" :label="'cloud_read_ebook'">书刊</el-radio>
          <el-radio class="title-radio" :label="'cloud_read_album'">专辑</el-radio>
          <el-radio class="title-radio" :label="'cloud_read_baozhi'">报系</el-radio>
        </el-radio-group>
      </div>
      <div class="module-list">
        <List class="questionnaire-list" :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="10">
          <template v-slot:listContent>
            <div class="paper-list-content">
              <el-table :data="tableData" border style="width: 100%" :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
                <el-table-column prop="worksName" label="作品名称" min-width="100"></el-table-column>
                <el-table-column prop="type" label="鉴权类型" min-width="50"> </el-table-column>
                <el-table-column prop="orderNum" v-if="currentModule === 'cloud_read_baozhi'" label="累计授权用户数" min-width="50"></el-table-column>
                <el-table-column prop="authUserTotalNum" v-else label="累计授权用户数" min-width="50"></el-table-column>
                <el-table-column prop="authUserNotExpiredNum" v-if="currentModule !== 'cloud_read_baozhi'" label="授权期内用户数" min-width="50"></el-table-column>
                <el-table-column prop="cumulativeEarn" label="累计收益" min-width="50"></el-table-column>
                <el-table-column label="操作" min-width="250">
                  <template slot-scope="scope">
                    <div class="option-button" @click="goContent(scope.row)">查看内容</div>
                    <div class="option-button" v-if="scope.row.secret === 1" @click="setAuth(scope.row)">读者鉴权方式</div>
                    <div class="option-button" v-else @click="setCharge(scope.row)">读者付费设置</div>
                    <div class="option-button" v-if="currentModule !== 'cloud_read_baozhi' || scope.row.secret !== 1" @click="showDetail(scope.row)">查看订单信息</div>
                    <div class="option-button" v-if="currentModule !== 'cloud_read_baozhi'" @click="showReader(scope.row)">读者列表</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </List>
      </div>
      <book-price ref="bookPrice" @saveSuccess="saveSuccess" :work-obj="editWork"></book-price>
      <shelf-price ref="shelfPrice" @saveSuccess="saveSuccess" :work-obj="editWork"></shelf-price>
      <order-list ref="orderList" :currentModule="currentModule" @exportOrder="exportOrder" :goods-obj="orderGoods"></order-list>
      <export-dialog ref="exportDialog" :type="exportType"></export-dialog>
      <auth-setting ref="authSetting" @saveSuccess="saveSuccess" :work-obj="editWork"></auth-setting>
      <baozhi-price ref="baozhiPrice" @saveSuccess="saveSuccess" :work-obj="editWork"></baozhi-price>
    </template>
  </div>
</template>

<script>
import ListHeader from '@components/list/listHeader'
import List from '@components/list/listFrame'
import BookPrice from './components/BookPrice'
import ShelfPrice from './components/ShelfPrice'
import OrderList from './components/OrderList'
import ExportDialog from './components/ExportDialog'
import chargeApi from '@api/chargeManager'
import AuthSetting from '@components/ChargeManagement/components/AuthSetting.vue'
import ReaderList from '@components/ChargeManagement/components/ReaderList.vue'
import BaozhiPrice from '@components/ChargeManagement/components/BaozhiPriceSetting.vue'
export default {
  name: 'index',
  data() {
    return {
      currentModule: 'cloud_read_ebook',
      showReaderList: false,
      exportType: '',
      totalCount: 0,
      tableData: [],
      editWork: {},
      orderGoods: {},
      currentPageNo: 1
    }
  },
  computed: {
    userName() {
      return localStorage.getItem('username')
    }
  },
  watch: {
    currentModule() {
      this.currentPageNo = 1
    }
  },
  created() {
    this.getGoodList('cloud_read_ebook')
  },
  methods: {
    getGoodList(type) {
      let _this = this
      _this.tableData = []
      let param = {
        userName: this.userName,
        worksType: type ? type : this.currentModule,
        pageSize: 10,
        pageNo: this.currentPageNo
      }
      chargeApi.getGoodsByPage(param).then((res) => {
        if (res.data && res.data.data) {
          let data = res.data.data.page
          if (data.result.length) {
            _this.tableData = data.result.map((item, index) => {
              if (item.worksType === _this.currentModule) {
                return {
                  ...item,
                  periodText: item.period !== null ? (item.period === 0 ? '永久' : item.period + '月') : '',
                  type: item.secret === 1 ? '内部阅读' : '付费阅读'
                }
              }
            })
          } else {
            _this.tableData = []
          }
          _this.totalPages = data.totalPages
          _this.totalCount = data.totalCount
        }
      })
    },
    changeModule(val) {
      this.getGoodList(val)
    },
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getGoodList(this.currentModule)
    },
    goContent(item) {
      let url = ''
      if (this.currentModule === 'cloud_read_ebook') {
        let routeUrl = this.$router.resolve({
          path: '/book',
          query: { id: item.worksId }
        })
        url = routeUrl.href
      } else if (this.currentModule === 'cloud_read_album') {
        this.$store.commit('config/UPDATE_BOOK_ID', item.id)
        this.$store.commit('edit/UPDATE_EDIT_HEADER_TYPE', 'catalog')
        let routeUrl = this.$router.resolve({
          path: '/bookshelfdetail',
          query: { id: item.worksId, openMode: item.openMode }
        })
        url = routeUrl.href
      } else if (this.currentModule === 'cloud_read_baozhi') {
        url = window.location.origin + '/ebook/baozhi/index.jhtml?id=' + item.worksId
      }
      window.open(url, '_blank')
    },
    setCharge(item) {
      this.editWork = item
      if (this.currentModule === 'cloud_read_ebook') {
        this.$refs.bookPrice.dialogVisible = true
      } else if (this.currentModule === 'cloud_read_album') {
        this.$refs.shelfPrice.dialogVisible = true
      } else if (this.currentModule === 'cloud_read_baozhi') {
        this.$refs.baozhiPrice.dialogVisible = true
      }
    },
    setAuth(item) {
      this.editWork = item
      this.$refs.authSetting.dialogVisible = true
    },
    saveSuccess(val) {
      this.getGoodList(val)
    },
    showDetail(val) {
      this.orderGoods = val
      this.$refs.orderList.dialogVisible = true
    },
    showReader(val) {
      this.orderGoods = val
      this.showReaderList = true
    },
    exportOrder(type, id) {
      this.exportType = type
      this.$refs.orderList.dialogVisible = false
      this.$refs.exportDialog.initSetting()
      this.$refs.exportDialog.dialogVisible = true
      this.$refs.exportDialog.module = type
      if (id) {
        this.$refs.exportDialog.goodsId = id
      }
    },
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0) {
        return 'text-align: center'
      }
    }
  },
  components: {
    BaozhiPrice,
    ReaderList,
    AuthSetting,
    ExportDialog,
    OrderList,
    ShelfPrice,
    BookPrice,
    ListHeader,
    List
  }
}
</script>

<style lang="scss" scoped>
.charge-manage {
  width: 100%;
  height: 100%;
  padding: 0 28px 18px 18px;
  position: relative;
  .navigation {
    .title-radio {
      font-size: 16px;
      font-weight: 600;
    }
  }
  .module-list {
  }
  .export-btn {
    width: 150px;
    font-size: 14px;
    color: #df5813;
    font-weight: 400;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 30px;
    img {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
}
</style>
<style lang="scss">
.charge-manage {
  .navigation {
    .title-radio {
      .el-radio__input {
        display: none;
      }
    }
  }
  .module-list {
    .option-button {
      display: inline-block;
      cursor: pointer;
      color: #df5813;
      margin-right: 20px;
    }
    .common-list-wrapper {
      .page-component {
        margin: 0;
        bottom: 20px;
      }
    }
  }
}
</style>
